export default __webpack_public_path__ + "static/media/logo.108ffd92.png";